import React from 'react';
import {getUniqueSublistItems, getSublistDictionary, getSublistforRefListValue, getItemforRefListValue} from './shared/SubListHelper.js'
import '../../styles.scss';

/**
 * Renders a pair of linked dropdown select boxes, one for the sublist and another for the ref data items in that sublist
 * @copyright Roche 2025
 * @author Nick Draper
 */
class SublistAwareDropdown extends React.Component {
  
  UNSAVED_CHANGES_MESSAGE = "Unsaved changes, click Save Changes to save";
    /**
     * Constructor 
     * 
     * @param props The properties passed
     */
    constructor(props) {
        super(props);
        let selectedSublist = this.props.subListBlankValue;
        if (this.props.value !== this.props.refListBlankValue) {
          const validSublist = getSublistforRefListValue(this.props.value, this.props.refList);
          if (validSublist) {
            selectedSublist = validSublist;
          }
        }
        
        this.state = {
          refListType:"",
          uniqueSublistItems:[],
          selectedSublist: selectedSublist,
          sublistDict: {},
        };

    }

    
  /**
   * Runs one after construction after everything is initialised
   */
  componentDidMount() {
    this.processSublistData();
  }
  
    /** Runs whenever the properties of the control are changed
   * @param prevProps The previous properties dictionary
   * @param prevState The previous state dictionary
   */
  componentDidUpdate(prevProps, prevState) {
    if (prevProps.refList !== this.props.refList) {
      this.processSublistData();
      const validSublist = getSublistforRefListValue(this.props.value, this.props.refList, this.state.selectedSublist);
      if (validSublist !==  this.state.selectedSublist) {
        this.setState({selectedSublist: validSublist});
      }
    }
    if (prevProps.value !== this.props.value
      && this.props.value !== this.props.refListBlankValue
    ) {
      const validSublist = getSublistforRefListValue(this.props.value, this.props.refList, this.state.selectedSublist);
      if (validSublist !==  this.state.selectedSublist) {
        this.setState({selectedSublist: validSublist});
      }
    }
  }


  processSublistData() {
    // extract summary info from the reference list
    if (this.props.refList) {
      const refList = this.props.refList;
      console.log("refList", refList);
      if (refList.length>0) {
        const refListType = refList[0].type;
        const uniqueSublistItems = getUniqueSublistItems(refList);
        const sublistDict = getSublistDictionary(refList);
        this.setState({
          refListType: refListType,
          uniqueSublistItems: uniqueSublistItems,
          sublistDict: sublistDict,
        })
      }
    }
  }


  /**
   * Renders the controls
   * @returns The JSX of the controls
   */
  render() {
    const keyPrefix = this.props.keyPrefix + SublistAwareDropdown + this.state.refListType;

    const selectedSublist = this.state.selectedSublist;
    const selectedRefListValue = this.props.value;
    const sublistBlankValue = this.props.subListBlankValue;
    const refListBlankValue = this.props.refListBlankValue;
    const refListItems = this.state.sublistDict[selectedSublist===sublistBlankValue?"":selectedSublist] ?? [];

    return (
      <div style={{display:"flex", alignItems:"center"}}
        key={keyPrefix + "div"}>
        <select style={(selectedSublist === null || 
                          selectedSublist === sublistBlankValue)?
                            { width: "30%", color:"grey"}:
                            { width: "30%"}}
            key={keyPrefix+"sublist"}
            value={selectedSublist}
            disabled={this.state.uniqueSublistItems.length === 0}
            onChange={(ev) => this.setState({ selectedSublist: ev.target.value,
                                              selectedRefListValue: refListBlankValue,
                                           }, ()=>this.props.onValueChanged(refListBlankValue, undefined))}>
            <option key={keyPrefix + "sublistNull"}  style={{color:"grey"}}>
              {this.state.uniqueSublistItems.length === 0?"No Sublists Defined":sublistBlankValue}</option>
            {this.state.uniqueSublistItems.map((item, index) => (
              <option style={{color:"black"}}
                key={keyPrefix + "sublist" + index}>
                {item}
              </option>
            ))}
          </select>
          <select style={(selectedRefListValue === null || 
                          selectedRefListValue === refListBlankValue)?
                            { width: "70%", color:"grey", marginLeft:this.props.gap}:
                            { width: "70%", marginLeft:this.props.gap}}
            key={keyPrefix+"reflist"}
            value={selectedRefListValue}
            onChange={(ev) => this.props.onValueChanged(ev.target.value, getItemforRefListValue(ev.target.value, this.props.refList))}>
            <option key={keyPrefix + "reflistNull"}  style={{color:"grey"}}>
              {refListBlankValue}</option>
            {((getItemforRefListValue(selectedRefListValue, this.props.refList) === undefined) && selectedRefListValue !== refListBlankValue)?
              <option key={keyPrefix + "reflistOther"}  style={{color:"black"}}>
                {selectedRefListValue}
              </option>
            :
              ""
            }
            {refListItems.map((item, index) => (
              <option style={{color:"black", whitespace:"pre"}}
                key={keyPrefix + "reflist" + index}>
                {item.description}
              </option>
            ))}
          </select>
          <div/>
      </div>
    );
  }
}

SublistAwareDropdown.defaultProps = {
  refList: [],
  keyPrefix: "",
  subListBlankValue: "Pick a Sublist...",
  refListBlankValue: "Pick a Value...",
  gap: "1em",
  onValueChanged: ()=>{},
}

export default SublistAwareDropdown
